/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import "../../../Components/Dashboard/EmpDashboard/Dashboard.css";
import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import { BiHomeAlt } from "react-icons/bi";
import { MdKeyboardArrowRight } from "react-icons/md";
import {
  Apiurl,
  GetToken,
  RemoveUserSession,
  formatNoOfDays,
} from "../../../Utils/utils";
import axios from "axios";
import userimg from "../../../Assets/Images/user6.png";
import { toast } from "react-toastify";
import Loader from "../../loader/loader";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { LiaUserClockSolid } from "react-icons/lia";
import { TiCalendarOutline } from "react-icons/ti";
import { LuFileAxis3D } from "react-icons/lu";
import { MdAvTimer } from "react-icons/md";
import { Modal } from "react-bootstrap";
import NewEmployeesModal from "../../../Components/Modals/NewEmployeesModal";
import EmpPendingDsrAlert from "./EmpPendingDsrAlert";

const EmpDashboard = () => {
  const [showModal, setShowModal] = useState(false);
  const [userTodaysAttendance, setUserTodaysAttendance] = useState();
  const navigate = useNavigate();
  const [showSidebar, setShowSidebar] = useState(true);
  const [yesterdayAttendanceData, setYesterdayAttendanceData] = useState([]);
  const [monthlyLateLeaves, setMonthlyLateLeaves] = useState([]);
  const [Thisyeardata, setThisyeardata] = useState("");
  const [loading, setLoading] = useState(false);
  const [lateleaves, setlateleaves] = useState("");
  const [currentMonthLeave, setCurrentMonthLeaves] = useState([]);
  const [Announceentdata, setAnnounceentdata] = useState([]);
  const [LeaveRequestdata, setLeaveRequestdata] = useState([]);
  const [errorLeaveType, setErrorLeaveType] = useState(false);
  const [leaveRequest, setLeaveRequest] = useState([]);
  const [findUserId, setFindUserId] = useState();
  const [leaveRequestDuplicate, setLeaveRequestDuplicate] = useState([]);
  const [showModalNew, setShowModalNew] = useState(false);
  const [showLeaveBreakdownModal, setShowLeaveBreakdownModal] = useState(false);
  const [leaveBreakdownData, setLeaveBreakdownData] = useState([]);
  const [loadingLeaveBreakdown, setLoadingLeaveBreakdown] = useState(false);

  const [deleteLeave, setDeleteLeave] = useState({
    IdDelete: "",
  });

  const LoginToken = GetToken();

  const addAMPM = (timeString) => {
    const time = new Date(`1970-01-01T${timeString}`);
    if (isNaN(time.getTime())) {
      return "";
    }
    const options = { hour: "numeric", minute: "numeric", hour12: true };
    return time.toLocaleTimeString("en-US", options);
  };

  const getStatusClass = (status) => {
    if (
      status === "Pending At Admin" ||
      status === "Pending At HR" ||
      status === "Pending At Team Lead" ||
      status === "YetToBeApprovedByAdmin" ||
      status === "YetToBeApprovedByHR" ||
      status === "YetToBeApprovedByTeamLead"
    ) {
      return "EMP-dashboard-status-pending";
    }

    if (
      status === "Rejected By Team Lead" ||
      status === "Rejected By HR" ||
      status === "Rejected By Admin" ||
      status === "Cancelled"
    ) {
      return "EMP-dashboard-status-rejected";
    }

    if (
      status === "Approved By Admin" ||
      status === "ApprovedByAdmin" ||
      status === "Approved By HR" ||
      status === "ApprovedByHR" ||
      status === "Approved By Team Lead" ||
      status === "ApprovedByTeamLead"
    ) {
      return "EMP-dashboard-status-approved";
    }

    return "EMP-dashboard-status-pending";
  };

  const timeString = yesterdayAttendanceData?.OutTime || "";
  const formattedTime = addAMPM(timeString);
  const timeINString = userTodaysAttendance?.InTime || "";
  const formattedINTime = addAMPM(timeINString);

  const TodaysAttendance = () => {
    setLoading(true);
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Attendence/GetTodayAttendanceEmployee`,
    };
    axios(option)
      .then((response) => {
        const data = JSON.parse(response?.data?.data);
        setUserTodaysAttendance(data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    TodaysAttendance();
  }, []);

  const userTime = () => {
    setLoading(true);
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Attendence/GetAttendanceByUser`,
    };
    axios(option)
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    userTime();
  }, []);

  const YesterdayAttendance = () => {
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Attendence/GetYesterdayAttendance`,
    };
    axios(option)
      .then((response) => {
        const data = JSON.parse(response?.data?.data);
        setYesterdayAttendanceData(data);
      })
      .catch(() => {});
  };

  useEffect(() => {
    YesterdayAttendance();
  }, []);

  const GetCurrentMonthLeave = () => {
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Leave/GetCurrentMonthLeaves`,
    };
    axios(option)
      .then((response) => {
        const data = JSON.parse(response?.data?.data);
        setCurrentMonthLeaves(data);
      })
      .catch(() => {});
  };

  useEffect(() => {
    GetCurrentMonthLeave();
  }, []);

  const [deleteClickable, setDeleteClickable] = useState("");

  const handleLeaveDelete = (item) => {
    setDeleteClickable(item);
    setShowModalNew(true);
  };

  const handleCloseModal = () => {
    setShowModalNew(false);
    setDeleteLeave({
      IdDelete: "",
    });
    setErrorLeaveType(false);
  };

  const handleAttendanceSearch = () => {
    setLoading(true);
    const LoginToken = GetToken();
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Leave/TotalLeaves`,
    };

    axios(option)
      .then((e) => {
        const data = JSON.parse(e?.data?.data || "[]");
        setLeaveRequest(Array.isArray(data) ? data : []);
        setLeaveRequestDuplicate(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong");

        if (error?.response?.status === 401) {
          toast.error("Your session has expired");
          RemoveUserSession();
          navigate("/", { replace: true });
        }

        setLoading(false);
      });
  };

  useEffect(() => {
    handleAttendanceSearch();
  }, []);

  const modalValidate = () => {
    if (deleteLeave?.IdDelete?.trim() === "") {
      toast.error("Please enter Reason");
      return false;
    }
    return true;
  };

  const handleDeleteLeave = (e) => {
    if (!modalValidate()) return;
    setLoading(true);
    const data = {};
    data.Id = deleteClickable?.Id;
    data.CancelReason = deleteLeave?.IdDelete;
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Leave/CancelLeave`,
      data: { data: JSON.stringify(data) },
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          toast.success(e?.data?.message);
          handleCloseModal();
          handleAttendanceSearch();
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };

  const EMPLeaveRequests = () => {
    const LoginToken = GetToken();
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Leave/TotalLeaves`,
    };
    axios(option)
      .then((e) => {
        const data = JSON.parse(e?.data?.data || "[]");
        setLeaveRequestdata(Array.isArray(data) ? data : []);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };

  // useEffect(() => {
  //   EMPLeaveRequests();
  // }, []);

  const CurrentYearLeaves = () => {
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Attendence/CurrentYearLeaves`,
    };
    axios(option)
      .then((response) => {
        const data = response?.data?.data;
        setThisyeardata(data);
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          toast.error("Your session has expired");
          RemoveUserSession();
          navigate("/", { replace: true });
        }
      });
  };

  useEffect(() => {
    CurrentYearLeaves();
  }, []);

  const fetchMonthlyLeaveBreakdown = () => {
    setLoadingLeaveBreakdown(true);
    setLeaveBreakdownData([]);

    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Attendence/MonthlyLeaveCountOfUser`,
    };

    axios(option)
      .then((response) => {
        if (response?.data?.success) {
          const data = JSON.parse(response?.data?.data || "[]");
          setLeaveBreakdownData(data);
        } else {
          setLeaveBreakdownData([]);
        }
        setLoadingLeaveBreakdown(false);
      })
      .catch((error) => {
        setLoadingLeaveBreakdown(false);
        if (error?.response?.status === 401) {
          toast.error("Your session has expired");
          RemoveUserSession();
          navigate("/", { replace: true });
        } else {
          toast.error("Failed to fetch leave breakdown");
        }
      });
  };

  const Lateleaves = () => {
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Attendence/GetMonthlyLateLeaves`,
    };
    axios(option)
      .then((response) => {
        const data = response?.data?.data;
        setlateleaves(data);
      })
      .catch(() => {});
  };

  useEffect(() => {
    Lateleaves();
  }, []);

  const Getannouncement = () => {
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Announcement/GetAnnouncements`,
    };
    axios(option)
      .then((response) => {
        const data = JSON.parse(response?.data?.data);
        setAnnounceentdata(data);
      })
      .catch(() => {});
  };

  useEffect(() => {
    Getannouncement();
  }, []);

  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, []);

  const GetProfile = () => {
    setLoading(true);
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Profile/GetProfile`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        const data = JSON.parse(e?.data?.data);
        setFindUserId(data.UserId);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    GetProfile();
  }, []);

  return (
    <>
      {loading ? <Loader /> : null}
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />
        <>
          <section
            className={
              showSidebar
                ? "dashboard-main-container"
                : "dashboard-main-container-new"
            }
          >
            <div className="all-icons">
              <div>
                <p className="DASHBOARD-MAIN-HEADING">Dashboard</p>
              </div>
              <div className="dashboiard-inner-header">
                <BiHomeAlt className="home-icon-header-inn" />
                <MdKeyboardArrowRight />
                <p>Home</p>
                <MdKeyboardArrowRight />
                <p>Dashboard</p>
              </div>
            </div>

            <div>
              <div className="dashboard-allcards-flex-container">
                <div className="dashboard-card-first-one">
                  <div className="dashboard-img-icon">
                    <LiaUserClockSolid />
                  </div>
                  <p className="dashboard-1st-card-heading">Today's Log in time</p>
                  <p className="dashboard-number-heading">
                    {formattedINTime ? formattedINTime.toLocaleString() : "-"}
                  </p>
                </div>

                <div className="dashboard-card">
                  <div className="dashboard-img-icon">
                    <MdAvTimer />
                  </div>
                  <p className="dashboard-1st-card-heading">
                    Yesterday’s Log out time
                  </p>
                  <p className="dashboard-number-heading">
                    {formattedTime ? formattedTime.toLocaleString() : "-"}
                  </p>
                </div>

                <div
                  className="dashboard-SECOND-card"
                  onClick={() => {
                    setShowLeaveBreakdownModal(true);
                    fetchMonthlyLeaveBreakdown();
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <div className="dashboard-img-icon">
                    <LuFileAxis3D />
                  </div>
                  <p className="dashboard-1st-card-heading">Leaves since 1 Jan</p>
                  <p className="dashboard-number-heading">
                    {Thisyeardata !== "" && Thisyeardata !== null
                      ? Number(Thisyeardata)
                      : "-"}
                    /18
                  </p>
                </div>

                <div className="dashboard-card-second-last">
                  <div className="dashboard-img-icon">
                    <TiCalendarOutline />
                  </div>
                  <p className="dashboard-1st-card-heading">Leaves this month</p>
                  <p className="dashboard-number-heading">
                    {currentMonthLeave ? currentMonthLeave : "-"}
                  </p>
                  <div className="dashboard-card-img-second-last"></div>
                </div>
              </div>
            </div>

            <div className="emp-dashboard-cards">
              <div className="emp-dashboard-Leave-Requests-main-container">
                <div className="emp-dashboard-Leave-outter">
                  <div className="emp-dashboard-card-header">
                    <div>
                      <p className="Leave-heading">Leave Requests</p>
                    </div>
                  </div>

                  <div className="emp-dashboard-table-container">
                    <table className="table-of-employee-leaves leave-request-desktop-table">
                      <thead className="thead-of-emp-table-leaves">
                        <tr>
                          <th className="hr-dashboard-no">Sr. No.</th>
                          <th className="hr-dashboard-date">Date</th>
                          <th className="hr-dashboard-type">Leave Type</th>
                          <th className="hr-dashboard-from">Leave From</th>
                          <th className="hr-dashboard-to">Leave To</th>
                          <th className="hr-dashboard-days">No Of Days</th>
                          <th className="hr-dashboard-Status">Status</th>
                          <th className="hr-dashboard-Action">Action</th>
                        </tr>
                      </thead>

                      <tbody className="tbody-ofemp-table-leaves">
                        {leaveRequest?.length > 0 &&
                          leaveRequest.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>
                                {moment(item?.AppliedDate).format("DD MMM YYYY")}
                              </td>
                              <td>{item?.LeaveTypes?.Name}</td>
                              <td>
                                {moment(item?.StartDate).format("DD MMM YYYY")}
                              </td>
                              <td>{moment(item?.EndDate).format("DD MMM YYYY")}</td>
                              <td>{formatNoOfDays(item?.NumberofDays)}</td>
                              <td>
                                <button className={getStatusClass(item?.Status)}>
                                  {item?.Status}
                                </button>
                              </td>
                              <td>
                                <button
                                  onClick={() => navigate("/Emp/EMPLeaves")}
                                  className="EMP-Approve-table-Approved-button-dashboard"
                                >
                                  Details
                                </button>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>

                    <div className="leave-request-mobile-cards">
                      {leaveRequest?.length > 0
                        ? leaveRequest.map((item, index) => (
                            <div className="leave-request-card" key={index}>
                              <div className="leave-request-card-top">
                                <div className="leave-request-card-sr">
                                  #{index + 1}
                                </div>
                                <button className={getStatusClass(item?.Status)}>
                                  {item?.Status}
                                </button>
                              </div>

                              <div className="leave-request-card-grid">
                                <div className="leave-request-card-item">
                                  <span className="leave-card-label">Date</span>
                                  <span className="leave-card-value">
                                    {moment(item?.AppliedDate).format(
                                      "DD MMM YYYY"
                                    )}
                                  </span>
                                </div>

                                <div className="leave-request-card-item">
                                  <span className="leave-card-label">
                                    Leave Type
                                  </span>
                                  <span className="leave-card-value">
                                    {item?.LeaveTypes?.Name}
                                  </span>
                                </div>

                                <div className="leave-request-card-item">
                                  <span className="leave-card-label">
                                    Leave From
                                  </span>
                                  <span className="leave-card-value">
                                    {moment(item?.StartDate).format(
                                      "DD MMM YYYY"
                                    )}
                                  </span>
                                </div>

                                <div className="leave-request-card-item">
                                  <span className="leave-card-label">
                                    Leave To
                                  </span>
                                  <span className="leave-card-value">
                                    {moment(item?.EndDate).format("DD MMM YYYY")}
                                  </span>
                                </div>

                                <div className="leave-request-card-item">
                                  <span className="leave-card-label">
                                    No Of Days
                                  </span>
                                  <span className="leave-card-value">
                                    {formatNoOfDays(item?.NumberofDays)}
                                  </span>
                                </div>
                              </div>

                              <div className="leave-request-card-actions">
                                <button
                                  onClick={() => navigate("/Emp/EMPLeaves")}
                                  className="EMP-Approve-table-Approved-button-dashboard"
                                >
                                  Details
                                </button>
                              </div>
                            </div>
                          ))
                        : null}
                    </div>
                  </div>
                </div>
              </div>

              <div className="emp-dashboard-notice-board-main-container">
                <div>
                  <p className="Notice-heading">Notice Board</p>
                </div>
                <div className="emp-dashboard-scroll">
                  <div>
                    <div>
                      {Announceentdata
                        ?.sort(
                          (a, b) =>
                            new Date(b.FlashTillDate) -
                            new Date(a.FlashTillDate)
                        )
                        ?.map((item, index) => (
                          <div key={index}>
                            {item?.AnnouncementTitle ||
                            item?.Description ||
                            item?.FlashTillDate ? (
                              <div className="emp-dashboard-notice-board-inner">
                                <img
                                  className="emp-dashboard-user-img"
                                  src={userimg || "/placeholder.svg"}
                                  alt=""
                                />
                                <div>
                                  <p className="emp-dashboard-notice-board-heading">
                                    {item?.AnnouncementTitle}
                                  </p>
                                  <p className="emp-dashboard-lorem">
                                    {item?.Description}
                                  </p>
                                  {item?.FlashTillDate ? (
                                    <p className="emp-dashboard-time">
                                      {moment(item?.FlashTillDate).format(
                                        "DD MMMM YYYY"
                                      )}
                                    </p>
                                  ) : null}
                                </div>
                              </div>
                            ) : null}
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      </div>

      {showLeaveBreakdownModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={() => setShowLeaveBreakdownModal(false)}
        >
          <div
            style={{
              backgroundColor: "#fff",
              borderRadius: "10px",
              padding: "24px",
              width: "90%",
              maxWidth: "700px",
              maxHeight: "80vh",
              overflowY: "auto",
              position: "relative",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px",
              }}
            >
              <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "600" }}>
                Monthly Leave Breakdown
              </h3>
              <button
                onClick={() => setShowLeaveBreakdownModal(false)}
                style={{
                  background: "none",
                  border: "none",
                  fontSize: "20px",
                  cursor: "pointer",
                  color: "#666",
                  lineHeight: 1,
                }}
              >
                ✕
              </button>
            </div>

            {loadingLeaveBreakdown ? (
              <div
                style={{ textAlign: "center", padding: "40px 0", color: "#666" }}
              >
                Loading...
              </div>
            ) : leaveBreakdownData.length === 0 ? (
              <div
                style={{ textAlign: "center", padding: "40px 0", color: "#666" }}
              >
                No leave records found for the current year.
              </div>
            ) : (
              leaveBreakdownData.map((monthItem, idx) => (
                <div
                  key={idx}
                  style={{
                    marginBottom: "16px",
                    border: "1px solid #e5e7eb",
                    borderRadius: "8px",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      backgroundColor: "#f3f4f6",
                      padding: "10px 16px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{ fontWeight: "600", fontSize: "15px" }}
                    >
                      {monthItem.MonthName} {monthItem.Year}
                    </span>
                    <span
                      style={{
                        backgroundColor: "#ef4444",
                        color: "#fff",
                        borderRadius: "20px",
                        padding: "2px 12px",
                        fontSize: "13px",
                        fontWeight: "600",
                      }}
                    >
                      Total: {monthItem.TotalLeaveWeight} day
                      {monthItem.TotalLeaveWeight !== 1 ? "s" : ""}
                    </span>
                  </div>

                  <div style={{ padding: "12px 16px" }}>
                    {Object.entries(monthItem.LeaveBreakdown || {}).map(
                      ([leaveType, detail], i) => (
                        <div
                          key={i}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-start",
                            padding: "8px 0",
                            borderBottom:
                              i <
                                Object.entries(monthItem.LeaveBreakdown || {})
                                  .length -
                                  1 || monthItem.WFHDays > 0
                                ? "1px solid #f3f4f6"
                                : "none",
                          }}
                        >
                          <div>
                            <span
                              style={{
                                fontWeight: "500",
                                fontSize: "14px",
                                color: "#374151",
                              }}
                            >
                              {leaveType.replace(/([A-Z])/g, " $1").trim()}
                            </span>
                            <div
                              style={{
                                marginTop: "4px",
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "4px",
                              }}
                            >
                              {(detail.Dates || []).map((date, di) => (
                                <span
                                  key={di}
                                  style={{
                                    fontSize: "11px",
                                    backgroundColor: "#eff6ff",
                                    color: "#3b82f6",
                                    borderRadius: "4px",
                                    padding: "1px 6px",
                                  }}
                                >
                                  {moment(date).format("DD MMM")}
                                </span>
                              ))}
                            </div>
                          </div>
                          <div
                            style={{
                              textAlign: "right",
                              flexShrink: 0,
                              marginLeft: "12px",
                            }}
                          >
                            <span style={{ fontSize: "13px", color: "#6b7280" }}>
                              {detail.Count} leave
                              {detail.Count !== 1 ? "s" : ""} ={" "}
                              <strong style={{ color: "#111827" }}>
                                {detail.TotalWeight} day
                                {detail.TotalWeight !== 1 ? "s" : ""}
                              </strong>
                            </span>
                          </div>
                        </div>
                      )
                    )}

                    {monthItem.WFHDays > 0 && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                          padding: "8px 0",
                        }}
                      >
                        <div>
                          <span
                            style={{
                              fontWeight: "500",
                              fontSize: "14px",
                              color: "#374151",
                            }}
                          >
                            WFH
                          </span>

                          <div
                            style={{
                              marginTop: "4px",
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "4px",
                            }}
                          >
                            {(monthItem.WFHDates || []).map((date, di) => (
                              <span
                                key={di}
                                style={{
                                  fontSize: "11px",
                                  backgroundColor: "#ecfdf5",
                                  color: "#059669",
                                  borderRadius: "4px",
                                  padding: "1px 6px",
                                }}
                              >
                                {moment(date).format("DD MMM")}
                              </span>
                            ))}
                          </div>
                        </div>

                        <div
                          style={{
                            textAlign: "right",
                            flexShrink: 0,
                            marginLeft: "12px",
                          }}
                        >
                          <span style={{ fontSize: "13px", color: "#6b7280" }}>
                            {monthItem.WFHDays} WFH day
                            {monthItem.WFHDays !== 1 ? "s" : ""}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}

      <EmpPendingDsrAlert />

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        className="modal-in-employee-table"
      >
        <NewEmployeesModal className="modal-main-inner-container" />
      </Modal>

      {showModalNew && (
        <div className="modal show edit-leaveModal" style={{ display: "block" }}>
          <Modal.Dialog>
            <Modal.Header
              className="delete-modal-header"
              closeButton
              onClick={handleCloseModal}
            >
              <Modal.Title>Cancel Confirmation</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="textarea-validate">
                <label htmlFor="">Reason</label>
                <textarea
                  type="text"
                  className="textarea-for-delete-leave-api"
                  value={deleteLeave?.IdDelete}
                  onChange={(e) =>
                    setDeleteLeave({
                      ...deleteLeave,
                      IdDelete: e?.target?.value,
                    })
                  }
                />
                {errorLeaveType === "userLeaveType" && !deleteLeave?.IdDelete ? (
                  <span className="reason-delete-leave">
                    Reason is required.
                  </span>
                ) : null}
              </div>
            </Modal.Body>
            <Modal.Footer className="Delete-fotter">
              <button
                className="Delete-modal-close-button"
                onClick={handleCloseModal}
              >
                Close
              </button>
              <button
                className="Delete-modal-delete-button"
                onClick={(e) => handleDeleteLeave(e)}
              >
                Delete
              </button>
            </Modal.Footer>
          </Modal.Dialog>
        </div>
      )}
    </>
  );
};

export default EmpDashboard;